import { createElement, useEffect, useRef, useState, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { Animated } from '@max/mbc-animated';
import AnimateView from '@max/mbc-animate-view';
import Icon from '@max/leez-icon';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { useLeaderboardNotice } from '../../hooks/useLeaderboardNotice';
import './index.scss';
// 与 scss 中 line-height: 36rpx 对应的像素值
const ITEM_HEIGHT = rpx2px(36);
// 每条展示停留时长（ms）
const DISPLAY_DURATION = 1500;
// 向上滑出动画时长（ms）
const SLIDE_DURATION = 400;
const NoticeSlider = (props) => {
    const { activityId } = props;
    const { leaderboardItems = [] } = useLeaderboardNotice({
        activityId
    });
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentIndexRef = useRef(0);
    const translateY = useRef(new Animated.Value(0));
    const timerRef = useRef(null);
    const totalRef = useRef(leaderboardItems.length);
    // 同步 totalRef，供 effect 闭包内读取最新 length
    totalRef.current = leaderboardItems.length;
    useEffect(() => {
        if (leaderboardItems.length <= 1)
            return;
        function scheduleNext() {
            timerRef.current = setTimeout(() => {
                // 向上滑出
                Animated.timing(translateY.current, {
                    toValue: -ITEM_HEIGHT,
                    duration: SLIDE_DURATION,
                    useNativeDriver: true,
                    easing: Animated.Easing.ease
                }).start(() => {
                    // 1. 先更新 ref（同步），用于渲染侧读取
                    const nextIndex = (currentIndexRef.current + 1) % totalRef.current;
                    currentIndexRef.current = nextIndex;
                    // 2. 更新 state 触发重渲染，新文本就位
                    setCurrentIndex(nextIndex);
                    // 3. 等下一个 tick，确保新文本已渲染到 Native 层后再重置位移
                    setTimeout(() => {
                        translateY.current.setValue(0);
                        scheduleNext();
                    }, 0);
                });
            }, DISPLAY_DURATION);
        }
        scheduleNext();
        return () => {
            clearTimeout(timerRef.current);
            translateY.current.setValue(0);
        };
    }, [leaderboardItems.length]);
    if (leaderboardItems.length === 0) {
        return null;
    }
    const currentItem = leaderboardItems[currentIndex];
    const nextItem = leaderboardItems[(currentIndex + 1) % leaderboardItems.length];
    function formatText(item) {
        return `${item.userName}用户已邀请${item.invitedCount}位好友获得 ${((item.cashBackAmount ?? 0) / 100).toFixed(2)} 元免单卡`;
    }
    return <View className="notice-slider-container">
      <Icon name="sound-line-regular" type="extraLarge1" iconFontType="meishi" color="#999999" size={14}/>
      <View className="notice-slider-text-wrapper">
        <AnimateView viewId="notice-slider-scroller" style={{
        flexDirection: 'column',
        transform: [{
                translateY: translateY.current
            }]
    }}>
          <Text className="notice-slider-text" numberOfLines={1}>
            {formatText(currentItem)}
          </Text>
          {leaderboardItems.length > 1 && <Text className="notice-slider-text" numberOfLines={1}>
              {formatText(nextItem)}
            </Text>}
        </AnimateView>
      </View>
    </View>;
};
export default memo(NoticeSlider);
